<template>
  <div
    class="floor-box"
    :class="{ current: current }"
    :style="index == 0 ? 'margin-top: 3px;' : ''"
    @click="changeCurrent()"
  >
    <div class="handel-box">
      <div
        class="up-icon"
        v-show="index != 0"
        @click.stop="upFloor(index)"
      ></div>
      <div
        class="down-icon"
        v-show="index != floorCount - 1"
        @click.stop="downFloor(index)"
      ></div>
      <div class="del-icon" @click.stop="delFloor(index)"></div>
    </div>
    <div class="floor-content">
      <div class="header-box">
        <p class="floor-name">限时折扣 {{ item.name }}</p>
        <div class="floor-more">
          <span>更多</span>
          <img
            src="../../../assets/images/pc-decoration/floor-more-icon.png"
            alt=">"
            class="floor-m ore-icon"
          />
        </div>
      </div>
      <!-- 折扣资料 -->
      <div v-if="item.style == 1" class="content-list">
        <mResourceDiscountItem
          v-for="(item2, index2) in item.contentList"
          :key="index2"
          :item2="item2"
        ></mResourceDiscountItem>
      </div>
      <!-- 折扣视频 -->
      <div v-if="item.style == 2" class="content-list">
        <mVideoDiscountItem
          v-for="(item2, index2) in item.contentList"
          :key="index2"
          :item2="item2"
        ></mVideoDiscountItem>
      </div>
    </div>
  </div>
</template>

<script>
import mFloorHandle from "../../../mixin/m-floor-handle";
import numberHandler from "../../../mixin/numberHandle";
import mVideoDiscountItem from "../discount/m-video-discount-item.vue";
import mResourceDiscountItem from "../discount/m-resource-discount-item.vue";
export default {
  name: "ShopCenterAdminWebMFloorDiscount",
  components: {
    mVideoDiscountItem,
    mResourceDiscountItem,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    floorCount: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  mixins: [mFloorHandle, numberHandler],
  mounted() {},

  methods: {
    // 选中楼层
    changeCurrent() {
      this.$emit("selectFloor", {
        id: 209,
        index: this.index,
        key: this.item.key,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.floor-box {
  position: relative;
  // height: 110px;
  padding: 15px;
  margin-top: 5px;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    background: #fff;
    border: 1px dashed #197dff;
    border-radius: 6px;
    border-top-right-radius: 0;
    box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
    .handel-box {
      display: flex;
    }
  }
  .handel-box {
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: -1px;
    right: -30px;
    width: 28px;
    padding-top: 15px;
    border-radius: 0px 5px 5px 0px;
    border-top: 1px dashed #197dff;
    border-right: 1px dashed #197dff;
    border-bottom: 1px dashed #197dff;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);
    .up-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/up-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/up-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .down-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/down-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/down-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .del-icon {
      width: 10px;
      height: 12px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;

      &:hover {
        background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .floor-content {
    // width: 100%;
    // height: 100%;
    padding: 20px 15px;
    background: #fff;
    border-radius: 8px;
    .header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .floor-name {
        color: #333;
        font-size: 17px;
        font-weight: 500;
        line-height: 17px;
      }
      .floor-more {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        span {
          color: #8895a9;
          font-size: 14px;
          line-height: 14px;
          margin-right: 3px;
        }

        img {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
.current {
  background: #fff;
  border: 1px dashed #197dff;
  border-radius: 6px;
  border-top-right-radius: 0;
  box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
  .handel-box {
    display: flex;
  }
}
</style>
